import React from "react";
import Card from "components/card";
import { useTranslation } from "react-i18next";

interface InfoPageProps {
  settingsType: "global" | "organization";
}

const InfoPage: React.FC<InfoPageProps> = ({ settingsType }) => {
  const { t } = useTranslation();
  const isGlobal = settingsType === "global";
  const titlePrefix = isGlobal ? t("settings.global") : t("settings.organization");
  const scope = isGlobal ? t("settings.scope.entireApplication") : t("settings.scope.organization");
  
  return (
    <div className="space-y-6">
      <Card extra="p-6">
        <h2 className="mb-4 text-xl font-semibold text-navy-700 dark:text-white">
          {t("settings.settingsInformation", { type: titlePrefix })}
        </h2>
        <div className="space-y-4 text-gray-600 dark:text-gray-300">
          <p>
            {t("settings.welcomeToSettings", { type: titlePrefix, scope })}
          </p>
          <div className="grid grid-cols-1 gap-4 md:grid-cols-2">
            <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
              <h3 className="mb-2 font-medium text-navy-700 dark:text-white">
                {t("settings.modelManagement")}
              </h3>
              <p className="text-sm">
                {t("settings.configureManage", { scope })}
              </p>
            </div>
            <div className="rounded-lg border border-gray-200 p-4 dark:border-gray-700">
              <h3 className="mb-2 font-medium text-navy-700 dark:text-white">
                {t("settings.modelAssignment")}
              </h3>
              <p className="text-sm">
                {t("settings.assignModels", { scope })}
              </p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  );
};

export default InfoPage;
